import React from 'react';

import { Backdrop } from '@mui/material';

import LoadingOwl from './LoadingOwl';

export const LoadingHOC = ({ loadingMessage = 'Please wait as we load data' }) => (
  <Backdrop
    style={{ backgroundColor: 'transparent' }}
    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={true}>
    <LoadingOwl loadingMessage={loadingMessage} />
  </Backdrop>
);
